import { FormControl, FormGroup, Validators } from '@angular/forms';

export class CompanyServiceRankingForm extends FormGroup<{
  id: FormControl<undefined | number>;
  rank: FormControl<undefined | string>;
  priorityLevel: FormControl<
    undefined | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10'
  >;
  CompanyId: FormControl<undefined | number>;
  allocationLimit: FormControl<undefined | null | number>;
  isTradeCategorySpecific: FormControl<undefined | boolean>;
  isTradeSpecific: FormControl<undefined | boolean>;
  createdAt: FormControl<undefined | null | Date>;
  updatedAt: FormControl<undefined | null | Date>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      rank: new FormControl<undefined | string>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      priorityLevel: new FormControl<
        undefined | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10'
      >('10', { nonNullable: true, validators: [Validators.required] }),
      CompanyId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      allocationLimit: new FormControl<undefined | null | number>(null),
      isTradeCategorySpecific: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isTradeSpecific: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      createdAt: new FormControl<undefined | null | Date>(null),
      updatedAt: new FormControl<undefined | null | Date>(null)
    });
  }
}
